<template>
    <div class="address-table-box">
        <el-input
            v-model="search"
            size="small"
            class="table-search"
            @keyup.native.enter="handleSearch(search)"
            @input="handleInput"
            :placeholder="$t('public.keyWord')"
            clearable>
        </el-input>
        <el-table
            :data="address_list"
            height="300"
            :default-sort="{prop: '', order: ''}"
            tooltip-effect="dark"
            @sort-change="handleTableSort"
            @selection-change="handleSelectionChange">
            <el-table-column
                type="selection"
                width="44">
            </el-table-column>
            <!-- 姓名 -->
            <el-table-column
                :label="$t('message.caddress.table1')"
                prop="consignee"
                align="center"
                width="100"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 地址 -->
            <el-table-column
                :label="$t('message.caddress.table2')"
                prop="address"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 电话 -->
            <el-table-column
                :label="$t('message.caddress.table3')"
                prop="mobile"
                align="center"
                width="180"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 是否默认 -->
            <el-table-column
                :label="$t('message.caddress.table4')"
                align="center"
                width="100"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <div>{{!row.status?$t('message.caddress.table4'):$t('message.caddress.isDefault')}}</div>
                </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column
                :label="$t('message.caddress.table5')"
                align="center"
                width="150">
                <template v-slot="{ row }">
                    <el-button
                        type="primary"
                        size="mini"
                        @click="handleModify(row.address_id)">
                        <span>{{$t("public.modifyBtn")}}</span>
                    </el-button>
                    <el-button
                        type="danger"
                        size="mini"
                        @click="handleDel(row.address_id)">
                        <span>{{$t("public.delBtn")}}</span>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
       <table-pagination
            :current-page="currentPage"
            :page-count="pageCount"
            :need-del="true"
            @current-change="handleCurrent"
            @handle-del="handleBatchDel">
        </table-pagination>
		<div style="padding: 10px; display: flex;justify-content: flex-end;">
			<el-pagination
			  @current-change="handleCurrent"
			  :current-page.sync="currentPage2"
			  :page-size="page.per_page"
			  layout="prev, pager, next, jumper"
			  :total="page.total"
			  background>
			</el-pagination>
		</div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { tableSortHandle } from "@/utils/publicMethod.js";

export default {
    mixins: [ tableSortHandle ],
    computed: mapState({
        address_list: state => state.user.address_list,
		page: state => state.user.page
    }),
	data() {
		return {
			currentPage2:0,
		}
	},
	watch:{
		currentPage(){
			this.currentPage2 = this.currentPage
		}
	},
    methods: {
        ...mapActions([
            "handleDelAddress"
        ]),
        handleDel(id){ // 删除按钮
            this.$confirm(this.$t("message.caddress.isDel"),{
                confirmButtonText: this.$t("public.confirmBtn"),
                cancelButtonText: this.$t("public.cancelBtn"),
                type: 'warning'
            }).then(() => this.handleDelAddress(id))
            .then((res) => {
                this.$emit('handleDelete', res)
            }).catch(() => {})
        }
    },
}
</script>

<style scoped>
.address-table-box{
    background: #fff;
}
.table-search{
    width: 200px;
    margin: 10px;
}
</style>
